import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ACCESS_STATUS_CONFIG } from '../constants';
import { useTranslation } from '../i18n/useTranslation';
import type { TranslationKey } from '../i18n';

interface Props {
  status: string;
  size?: 'small' | 'medium';
}

const STATUS_LABEL_KEYS: Record<string, TranslationKey> = {
  full_access: 'accessStatus.full_access',
  org_linked_no_user: 'accessStatus.org_linked_no_user',
  not_linked: 'accessStatus.not_linked',
  request_pending: 'accessStatus.request_pending',
  instant_available: 'accessStatus.instant_available',
  active: 'accessStatus.active',
};

export default function AccessStatusChip({ status, size = 'small' }: Props) {
  const t = useTranslation();
  const c = ACCESS_STATUS_CONFIG[status] || ACCESS_STATUS_CONFIG.not_linked;
  const isSmall = size === 'small';
  const labelKey = STATUS_LABEL_KEYS[status] ?? STATUS_LABEL_KEYS.not_linked;
  const label = t(labelKey);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: isSmall ? 1.25 : 1.5,
        py: isSmall ? 0.4 : 0.6,
        borderRadius: '6px',
        bgcolor: c.bgColor,
      }}
    >
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          bgcolor: c.dotColor,
          flexShrink: 0,
        }}
      />
      <Typography
        sx={{
          fontSize: isSmall ? '0.72rem' : '0.8rem',
          fontWeight: 600,
          color: c.textColor,
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
